// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".join_form input.el-input__inner,\n.city .el-input {\n  height: 0.260417rem;\n  line-height: 0.260417rem;\n  border-radius: inherit;\n  border: none;\n}", ""]);
// Exports
module.exports = exports;
